import { useTheme } from '../../../contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { useState } from 'react';
import { HomeTopBarHeader } from './HomeTopBarHeader';
import { HomeTopBarBody } from './HomeTopBarBody';
import { ExpandableTopBar } from '@/presentation/components/common/appBar/expandableTopBar/ExpandableTopBar';

export const HomeTopBar = () => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();
  const [isExpanded, setIsExpanded] = useState(false);

  const collapsedHeight = `calc(${responsive.topBar.height}px + ${responsive.safeArea.top})`;

  return (
    <ExpandableTopBar
      collapsedHeight={collapsedHeight}
      isExpanded={isExpanded}
      onExpandedChange={setIsExpanded}
      backdropColor={`${theme.topBarBackdrop}`}
      header={
        <HomeTopBarHeader
          isExpanded={isExpanded}
          onExpandedChange={setIsExpanded}
        />
      }
      body={<HomeTopBarBody />}
    />
  );
};
